<template>
<div>
  <div>
    <div class="search-wrap">
      <el-button size="mini" @click="saveListForm">保存</el-button>
      <el-button size="mini" @click="search">查询</el-button>
<!--      <el-button size="mini" @click="printList()" style="margin-right: 5px;">打印</el-button>-->
<!--      <el-button size="mini" @click="navBack()">返回</el-button>-->
    </div>

    <div style="margin-bottom: 10px;">
      <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
        <el-descriptions-item label="仪表编号">
          <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" clearable @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="当前房产">
          <el-input size="mini" placeholder="请选择房产" v-model="where.house_name" clearable @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <!--          <el-descriptions-item label="抄表类型">-->
        <!--            <el-radio disabled size="mini" v-for="item in [{name:'正常抄表',val:1},{name:'中途抄表',val:2}]"-->
        <!--                      :key="item.val" v-model="where.note_type" :label="item.val">-->
        <!--              {{ item.name }}-->
        <!--            </el-radio>-->
        <!--          </el-descriptions-item>-->
        <!--          <el-descriptions-item label="线路">-->
        <!--            <el-input size="mini" placeholder="请输入线路" v-model="where.line" clearable></el-input>-->
        <!--          </el-descriptions-item>-->
        <el-descriptions-item label="仪表状态">
          <el-checkbox-group v-model="where.status_ids" @change="pageChange(1)">
            <el-checkbox v-for="item in [{name:'在用',val:1},{name:'停用',val:2}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-descriptions-item>
        <el-descriptions-item label="仪表名称">
          <el-input size="mini" placeholder="请输入仪表名称" v-model="where.name" clearable @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="仪表类型">
          <el-select size="mini" style="width: 100%" v-model="where.meter_type" filterable placeholder="类型" class="kuan" @change="pageChange(1)">
            <el-option
              v-for="item in meter_type_list"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="仪表性质">
          <el-checkbox-group v-model="where.meter_nature_ids" @change="pageChange(1)">
            <el-checkbox v-for="item in meter_nature_list" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-descriptions-item>
<!--        <el-descriptions-item label="审核标志">-->
<!--          <el-checkbox-group v-model="where.is_examine_ids" @change="pageChange(1)">-->
<!--            <el-checkbox v-for="item in [{name:'未审核',val:0},{name:'已审核',val:1}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>-->
<!--          </el-checkbox-group>-->
<!--        </el-descriptions-item>-->
        <el-descriptions-item label="能耗类型">
          <el-checkbox-group v-model="where.energy_ids" @change="pageChange(1)">
            <el-checkbox v-for="(item,index) in energy_list" :disabled="!isEnergyAble(item.val)" :label="item.val" :key="index">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-descriptions-item>
        <el-descriptions-item label="抄表日期">
          <div v-if="where.read_type===2">
            <el-row>
              <el-col :span="11">
                <el-date-picker
                  style="width: 100%"
                  size="mini"
                  v-model="where.start_time"
                  :clearable="false"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" @change="pageChange(1)">
                </el-date-picker>
              </el-col>
              <el-col :span="2">
                至
              </el-col>
              <el-col :span="11">
                <el-date-picker
                  style="width: 100%"
                  size="mini"
                  v-model="where.end_time"
                  :clearable="false"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" @change="pageChange(1)">
                </el-date-picker>
              </el-col>
            </el-row>
          </div>
          <div v-if="where.read_type===1">
            <el-date-picker
              style="width: 100%"
              size="mini"
              v-model="where.read_month"
              :clearable="false"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM" @change="pageChange(1)">
            </el-date-picker>
          </div>
          <div style="margin-top: 10px;">
            <el-radio v-model="where.read_type" :label="1">按月</el-radio>
            <el-radio v-model="where.read_type" :label="2">自定义</el-radio>
          </div>
        </el-descriptions-item>
        <!--          <el-descriptions-item label="用量异常">-->
        <!--            <el-radio disabled size="mini" v-for="item in [{name:'是',val:1},{name:'否',val:0}]"-->
        <!--                      :key="item.val" v-model="where.is_accident" :label="item.val">{{ item.name }}</el-radio>-->
        <!--          </el-descriptions-item>-->
      </el-descriptions>
    </div>

    <div class="header-tip">
      抄表数：{{count_obj.read}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      锁定数：{{count_obj.freeze}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      已审数：{{count_obj.examine}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>

    <div>
      <el-table size="mini" height="47vh" width="99%" border v-if="pageData" v-loading="loading" :data="pageData.list" @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55" fixed>
        </el-table-column>
        <el-table-column prop="meter_type_name" label="仪表类型" align="center" width="80" fixed></el-table-column>
        <el-table-column prop="number" label="仪表编号 " align="center" width="140" fixed>
          <template slot-scope="scope">
            <el-link type="primary" @click="edit(scope.row)">{{scope.row.number}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="仪表名称 " align="center" width="100"></el-table-column>
        <el-table-column prop="old_dosage_number" label="去年同期用量" align="center" width="100"></el-table-column>
        <el-table-column prop="last_read_time" label="上期抄表日期" align="center" width="100"></el-table-column>
        <el-table-column prop="last_read_number" label="上期读数" align="center" width="100"></el-table-column>
        <el-table-column prop="read_number" label="本期读数" align="center" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.is_examine">{{scope.row.read_number}}</span>
            <el-input v-if="!scope.row.is_examine" :ref="'input_'+scope.$index" :data-index="'input_'+scope.$index" size="mini" placeholder="请输入本期读数" @keydown.native="nextLine(scope.row,scope.$index,$event)" @input="onDosageNumber(scope.row)" @change="isDosageNumber(scope.row,'input_'+scope.$index)" v-model="scope.row.read_number" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="read_time" label="抄表日期" align="center" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.is_examine">{{scope.row.read_time}}</span>
            <el-date-picker
              v-if="!scope.row.is_examine"
              style="width: 100%"
              size="mini"
              v-model="scope.row.read_time"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="updateTime"
              placeholder="选择日期">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column prop="admin_name" label="抄表人" align="center" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.is_examine">{{scope.row.admin_name}}</span>
            <el-input v-if="!scope.row.is_examine" size="mini" placeholder="请输入抄表人" v-model="scope.row.admin_name" @focus="selectUser(scope.row)" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="dosage_number" label="本期用量" align="center" width="100">
          <template slot-scope="scope">
            <span :style="{color:(scope.row.dosage_number<0?'#ff0000':'#000000')}">{{scope.row.dosage_number}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="house_name" label="所在房产" align="center" width="200"></el-table-column>
        <el-table-column prop="charging_standard_name" label="收费标准 " align="center" width="250"></el-table-column>
        <el-table-column prop="charging_standard_money" label="费用单价 " align="center" width="100"></el-table-column>
      </el-table>
    </div>

    <div style="margin-top: 20px;text-align: right;margin-right: 20px;">
      <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
    </div>
  </div>

  <!-- 修改窗口 -->
  <MeterInfo ref="MeterInfo" />

  <select-personnel ref="selectPersonnel" />
</div>
</template>

<script>
import SelectPersonnel from "../../../Personnel/components/selectPersonnel";
import UploadFilesSysc from "../../../Contract/components/UploadFilesSysc";
import moment from "moment";
import MeterInfo from "../meter/components/MeterInfo";
import CommonMixin from "../../common/CommonMixin";
import MeterHttp from "../../common/MeterHttp";

export default {
  name: "MeterNoteWrite",
  components: {MeterInfo, SelectPersonnel, UploadFilesSysc},
  mixins:[CommonMixin],
  inject:['mainObj','componentId','setComponentId'],
  data() {
    return {
      host_url: "",
      keyword: '',
      loading: false,
      where: {
        meter_type: "",
        house_name: "",
        number: "",
        charging_standard: "",
        status: "",
        status_ids: [1],
        line: "",
        meter_nature: "",
        meter_nature_ids: [1,2,3,4],
        name: "",
        note_status:"",
        note_status_ids:[0,1],
        start_time:moment(new Date()).startOf('month').format("YYYY-MM-DD"),
        end_time:moment(new Date()).endOf('month').format("YYYY-MM-DD"),
        read_month:moment(new Date()).endOf('month').format("YYYY-MM"),
        read_type:1,
        energy_ids:this.getDefaultEnergyIds(),
        meter_virtually:[1]
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 30,
        page: 1
      },
      treeDialogVisible: false,
      uploadUrl: "",
      month_value: "",
      business_list: [],
      entry_type_name: "",
      multipleSelection: [],
      meter_type_list: [],
      house_charge_list:[],
      chargeItem_name_id:"",
      meter_nature_list:[{name:'分表',val:1},{name:'总表',val:2},{name:'分摊表',val:3},{name:'电力负荷表',val:4}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      charging_standard:"",
      count_obj:{},
    }
  },
  mounted() {
    const that=this;
    this.host_url = __HTTP__.defaults.baseURL;
    // this.month_value=CommonHelp.date("YYYY-MM");
    this.getMeterTypeList()

    this.where.house_name=that.mainObj.house_name;
    this.where.house_name&&this.getList();
  },
  watch: {
    "where.meter_type":function (n) {
      this.chargeItem_name_id=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_id||"";
      this.getHouseChargeList();
    },
    "mainObj.house_name":function (n) {
      const that=this;
      this.where.house_name=n;
      this.getList();
    }
  },
  computed: {
    multipleSelection_meter_type_num(){
      let set=new Set();
      this.multipleSelection.map(ret=>{
        set.add(ret.meter_type)
      });
      return Array.from(set).length;
    }
  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id: '',
        pid:'',
        name: "",
        number: "",
        project_id: "",
        house_id: "",
        house_name: "",
        house_number: "",
        meter_number: "",
        meter_type: "",
        charge_type: "",
        charging_standard: "",
        sort: "0",
        status: 1,
        meter_nature: "",
        magnification: "",
        start_number: "",
        return_trip: "",
        install_time: "",
        reading_time: "",
        position: "",
        lat: "",
        lng: "",
        files: "",
        line: "",
        specifications: "",
        remarks: "",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = reObject(this.where);
      // where.is_update=0;
      MeterHttp.post("MeterNote/getMasterList",{
        project_id:that.mainObj.project_id,
        where: JSON.stringify(where),
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
        that.getCount();
      })
    },
    getCount() {
      const that = this;
      let where = reObject(this.where);
      MeterHttp.post("MeterNote/getCount",{
        project_id:that.mainObj.project_id,
        where: JSON.stringify(where),
        user_type:(that.$route.query.type||0)
      }, res => {
        if (res.code) {
          that.count_obj = res.data
        }
      });
    },
    getListForm(){
      return this.pageData.list.filter(ret=>{
        return !!(ret.read_number&&ret.read_time);
      }).map(ret=>{
        return {
          meter_id:ret.id,
          read_number:ret.read_number,
          dosage_number:ret.dosage_number,
          last_read_number:ret.last_read_number,
          read_time:ret.read_time,
          last_read_time:ret.last_read_time,
          admin_id:ret.admin_id,
          admin_name:ret.admin_name
        }
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    edit(item) {
      this.$refs.MeterInfo.show(item);
    },

    saveListForm(){
      var that=this;
      let bool = true;
      this.pageData.list.map(ret=>{
        if(ret.read_number){
          if(ret.read_time == ''){
            bool = false;
          }
        }
      })
      if(bool === false){
        this.$Message.error('抄表日期不能为空');
        return false;
      }

      let form_data=reObject(that.getListForm());
      ERP.showLoading();
      MeterHttp.post("MeterNote/saveList?user_type="+(that.$route.query.type||0),{
        project_id:that.mainObj.project_id,
        form_list:JSON.stringify(form_data)
      }, res => {
        ERP.hideLoading();
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.getList()
        }
      })
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_id,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    getHouseChargeList(){
      var that=this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      this.chargeItem_name_id&&(where.chargeItem_name_id=this.chargeItem_name_id);
      if(where.pindex_id){
        MeterHttp.get("HouseCharge/getList",{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        },ret=>{
          if(ret.code){
            that.house_charge_list=ret.data.list;
          }
        })
      }

    },
    navToMeterExcel(){
      ERP.navigateTo("/meter/meterExcel?type="+(this.$route.query.type||0));
    },
    onDosageNumber(item){
      item.dosage_number=(item.read_number-item.last_read_number)*item.magnification;
      item.amount=(item.dosage_number*item.charging_standard_money);
    },
    isDosageNumber(item,el){
      const self=this;
      if(item.dosage_number<0){
        self.$confirm("该读数小于0了","提示",{
          confirmButtonText: '调整',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log(el)
          self.$refs[el].focus()
        });
      }
    },
    printList(){
      this.$router.push({path:"/meter/meterNotePrint",query:reObject(this.where)})
    },
    navBack(){
      ERP.navigateBack()
    },
    selectUser(item){
      const that=this;
      that.$refs.selectPersonnel.show({user_ids:"",user_len:1},ret=>{
        if(ret.length){
          item.admin_name=ret[0].username;
          item.admin_id=ret[0].id;

          that.$confirm("是否全部替换为该人员抄表","提示",{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.pageData.list.map(mtn=>{
              mtn.admin_name=ret[0].username;
              mtn.admin_id=ret[0].id;
            })
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
          });


        }else {
          item.admin_name="";
          item.admin_id="";
          that.$confirm("是否清除抄表人员","提示",{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.pageData.list.map(mtn=>{
              mtn.admin_name=ret[0].username;
              mtn.admin_id=ret[0].id;
            })
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
          });
        }
      })
    },
    updateTime(val){
      const that=this;
      that.$confirm(val?"是否设置为当前全部抄表时间":"是否清除当前全部抄表时间","提示",{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.pageData.list.map(mtn=>{
          mtn.read_time=val;
        })
        this.$message({
          type: 'success',
          message: val?'修改成功!':"清除成功"
        });
      });
    },
    nextLine(item,index,event){
      const that=this;
      // that.$refs['input_'+index+1].focus();
      // console.log(event.code);
      if(event.code==='ArrowDown'||event.code==='ArrowUp'){
        // console.log('input_'+(index+1))
        // console.log(that.$refs['input_'+(index+1)])
        event.code==='ArrowDown'&&index<=that.pageData.list.length&&that.$refs['input_'+(index+1)].focus();
        event.code==='ArrowDown'&&index>0&&that.$refs['input_'+(index-1)].focus();
      }
    },
  }
}

function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>
@import "../../common";
.header-tip{
  margin: 5px 0;
  padding: 5px 10px;
  background-color: #f56c6c;
  color: #FFFFFF;
  border-radius: 4px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_note/MeterNoteWrite.vue